import React from 'react';
import InlineError from 'commons/src/components/errorComponents/InlineError';
import { sensorUnits } from 'commons/src/constants';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { formatRating, sensorRating } from 'commons/src/sensorRatingUtils';
import { ReportSensorThresholds } from '../../../../models/common';
import styles from './TableRowSensorStatus.module.scss';

type Props = {
    value?: number;
    isAverage?: boolean;
    sensorRanges: ReportSensorThresholds;
    sensor: string;
};

const TableRowSensorStatus = (props: Props): React.ReactElement | null => {
    const {
        sensor,
        value,
        isAverage,
        sensorRanges: { ranges, unit },
    } = props;

    const valueRating = sensorRating(ranges, value);
    const displayedUnit: string =
        sensor === SensorTypes.temp ? `${sensorUnits[unit]}${(unit as string).toUpperCase()}` : sensorUnits[unit];
    if (value === undefined) {
        if (isAverage) {
            return <InlineError message="NoData" />;
        }
        return null;
    }

    return (
        <div className={styles.sensorStatusContainer}>
            <div className={styles.sensorStatusRow}>
                <span className={styles.sensorValue}>{parseFloat(value.toFixed(1))}</span>
                <span>{displayedUnit}</span>
            </div>
            {valueRating && <span className={styles[valueRating]}>{formatRating(valueRating)}</span>}
        </div>
    );
};

export default TableRowSensorStatus;
